import { withI18nPlaceholders } from '@change-corgi/core/react/i18n';

import I18N_PLACEHOLDERS from 'config/i18n/placeholders/mobileAppDownload/bottom-banner.yml';

import { Banner } from './component/Banner';

type AppDownloadBottomBannerProps = {
	enabled: boolean;
	ownPetition: boolean;
	sourceLocation: string;
};

export const AppDownloadBottomBanner = withI18nPlaceholders(
	I18N_PLACEHOLDERS,
	function AppDownloadBottomBannerEntry({
		enabled,
		ownPetition,
		sourceLocation,
	}: AppDownloadBottomBannerProps): React.JSX.Element | null {
		if (!ownPetition) return null;

		return <Banner sourceLocation={sourceLocation} enabled={enabled} />;
	},
);
